import pluralize from 'pluralize';
import { type MouseEvent, memo, useCallback, useMemo } from 'react';

import { Board as BoardIcon } from '@air/next-icons';

export type BoardMetaDataProps = {
  itemCount?: number;
};

export const BoardMetaData = memo(({ itemCount }: BoardMetaDataProps) => {
  const itemCountPhrase = useMemo(() => {
    // itemCount will be undefined when a new board is created in Table View
    const count = itemCount ?? 0;

    return <> &middot; {pluralize('item', count, true)}</>;
  }, [itemCount]);
  // Prevents the button from triggering selection of the row when clicking on the button.
  const onMouseDown = useCallback((event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
  }, []);

  return (
    <div className="pointer-events-none -ml-1 flex items-center gap-1">
      <div
        className="pointer-events-none flex h-5 min-w-0 items-center gap-1 rounded-4 px-1 font-semibold text-12 text-grey-11 hover:bg-grey-3"
        data-disableselect="true"
        onMouseDown={onMouseDown}
      >
        <BoardIcon className="size-3 shrink-0" />
        <span className="truncate">Board{itemCountPhrase}</span>
      </div>
    </div>
  );
});

BoardMetaData.displayName = 'BoardMetaData';
